<template>
    <painel titulo="Aplicações" icone="pi pi-users" v-if="mostrarTabela">
        <tabela
            :data="aplicacoes"
            dataKey="aplicacoesId"
            :globalFilterFields="['codigo', 'descricao', 'status', 'acessoAte', 'validade', 'dataAtualizacao']"
            stateKey="dt-usuarios"
        >
            <template #botoes>
                <btn-inserir></btn-inserir>
            </template>
            <template #conteudo>
                <Column headerStyle="width: 3em">
                    <template #body="slotProps">
                        <btn-detalhar :aplicacoes="slotProps.data"></btn-detalhar>
                    </template>
                </Column>
                <Column field="codigo" header="Código" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.codigo }}
                    </template>
                </Column>
                <Column field="descricao" header="Descrição" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.descricao }}
                    </template>
                </Column>
                <Column field="statusDescr" header="Status" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.statusDescr }}
                    </template>
                </Column>
                <Column field="fimVigencia" header="Acesso até" :sortable="true">
                    <template #body="slotProps">
                        {{ slotProps.data.fimVigencia ? $moment(slotProps.data.fimVigencia).format('DD/MM/YYYY') : 'NÃO ESPECIFICADO' }}
                    </template>
                </Column>
                <Column field="dataAtualizacao" header="Atualizado em" :sortable="true">
                    <template #body="slotProps">
                        {{ $moment(slotProps.data.dataAtualizacao).format('DD/MM/YYYY') }}
                    </template>
                </Column>
            </template>
        </tabela>
    </painel>
    <router-view></router-view>
</template>

<script>
import AplicacoesServicos from './services';
import BtnDetalhar from './BtnDetalhar.vue';
import BtnInserir from './BtnInserir.vue';

export default {
    components: {
        BtnInserir,
        BtnDetalhar,
    },

    data() {
        return {
            aplicacoes: null,
            itensPorPagina: 10,
        };
    },

    methods: {
        obterAplicacoes() {
            this.$store.dispatch('addRequest');
            AplicacoesServicos.obterTodas().then((response) => {
                if (response) {
                    if (response.success) {
                        this.aplicacoes = response.data;
                    } else {
                        this.aplicacoes = [];
                    }
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },

    mounted() {
        this.obterAplicacoes();
    },
    computed: {
        mostrarTabela() {
            return this.$route.name === 'Aplicacoes';
        },
    },

    watch: {
        $route(to) {
            if (to.name === 'Aplicacoes') {
                if (this.$store.getters.recarregar) {
                    this.obterAplicacoes();
                    this.$store.dispatch('setRecarregar', false);
                }
            }
        },
    },
};
</script>
